import PlayerImage from './image';
import Icon from '@components/atoms/icon';
import { BodyRegular } from '@components/atoms/typography';
import type { Player as FfhPlayer } from '@api-service/players';

type PlayerChipProps = {
  player: FfhPlayer;
  handleDelete?: (player: FfhPlayer) => void;
  border?: string;
};

const PlayerChip = ({ handleDelete, player, border }: PlayerChipProps) => (
  <li className="flex items-center mb-5 mr-1">
    <div
      className={`w-[18px] mr-3 border-t-2 flex my-1 justify-center items-center bg-white ${
        border ?? ''
      }`}
    ></div>
    <div className="relative flex items-center justify-center w-8 h-8 mr-2 text-xs rounded-full">
      <PlayerImage
        className="h-full"
        src={player.imageUrl}
        kitImageUrl={player.kitImageUrl}
        height={30}
        width={30}
        fallbackHeight={24}
        fallbackWidth={24}
      />
    </div>
    <div>
      <BodyRegular>{player?.displayName}</BodyRegular>
    </div>
    {handleDelete && (
      <div className="flex ml-1 text-gray-400 cursor-pointer hover:text-gray-500">
        <Icon name="Cancel" onClick={() => handleDelete(player)} />
      </div>
    )}
  </li>
);

export default PlayerChip;
